import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import { EditLocationsNestedContainer, IEditLocationsContainerProps } from './edit-locations-form-nested.container';

export const EditLocationsContainer = (props: IEditLocationsContainerProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Edit Locations"
    >
      <EditLocationsNestedContainer
        {...props}
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
      />
    </FormContainer>
  );
};
